import React from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";

import { getPerformYardUsers } from "../../../Api/services/logan-users";

export const UserSelector = (props) => {
	/**
	 * Fetch PerformYard users.
	 */
	const { data, isLoading } = useQuery({
		queryKey: ["performyard-users"],
		queryFn: () => getPerformYardUsers(),
		refetchInterval: 30_000,
	});

	const users = (data ?? []).map((user) => ({
		value: user._id,
		label: user.displayName,
	}));

	return (
		<Select
			value={props.value}
			onChange={props.onChange}
			options={users}
			isSearchable
			isClearable
			isLoading={isLoading}
		/>
	);
};
